export default __webpack_public_path__ + "static/media/shareBG4x.45f727f4.png";